import { GameClient } from '@/features/game-client/game-client';
import { WindowTitle } from '@/features/window-title';

const App = () => (
  <>
    <WindowTitle />
    <GameClient />
  </>
);

export default App;
